/**
 * Network timeouts tuned for high-latency / unstable mobile connections.
 * Used by Supabase fetch, auth lock, login, and React Query retries.
 */
export const NETWORK_CONSTANTS = {
  /** Browser → Supabase PostgREST / Storage / Auth HTTP ceiling. */
  SUPABASE_FETCH_TIMEOUT_MS: 90_000,

  /** Navigator LockManager wait for cross-tab auth token coordination. */
  SUPABASE_AUTH_LOCK_TIMEOUT_MS: 60_000,

  /** Extra time after lock timeout before forcing auth hydration UI. */
  AUTH_HYDRATE_BUFFER_MS: 15_000,

  /** Client POST to `/api/auth/login` (includes session + profile fetch). */
  LOGIN_TIMEOUT_MS: 60_000,

  /** React Query retries for live operational queries on transient failures. */
  QUERY_RETRY_MAX_ATTEMPTS: 5,
  /** Retries for catalog/config reads (fewer attempts than live boards). */
  QUERY_RETRY_MAX_ATTEMPTS_STATIC: 3,
  QUERY_RETRY_BASE_DELAY_MS: 2_000,
  QUERY_RETRY_MAX_DELAY_MS: 30_000,

  /** Show a “still loading” notice after this delay while a fetch remains in flight. */
  SLOW_FETCH_NOTICE_MS: 4_000,
} as const
